module.exports = __webpack_public_path__ + "assets/inschrijven3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/inschrijven3.jpg
// module id = 364
// module chunks = 0